enum StoreActions {
  IS_LOADER_SHOW = 'PAGE_LOADER/IS_LOADER_SHOW',
  IS_LOADER_HIDE = 'PAGE_LOADER/IS_LOADER_HIDE',
}

export const ActionTypes_PageLoader = {
  StoreActions,
}
